import React from "react";
import { Trans } from "react-i18next";

const Footer = () => {
  return (
    <div className="d-flex flex-column align-items-center justify-content-start pt-3">
      <a href="/terms" className="text-black pb-1 smallText">
        <Trans i18nKey={"common_text.terms_and_conditions"} />
      </a>
      <a href="/privacy" className="text-black pb-1 smallText">
        <Trans i18nKey={"common_text.privacy_policy"} />
      </a>
      <a
        href="mailto:support@freelanz.app"
        className="text-black pb-1 smallText"
      >
        support@freelanz.app
      </a>
      <p className="text-black pt-2 text-center smallText">
        <Trans i18nKey={"common_text.copy_right"} />
      </p>
    </div>
  );
};

export default React.memo(Footer, () => true);
